/** Apollo watch options for catalog, tenant, and other read-mostly data. */
export const CATALOG_FETCH_POLICY = 'cache-first' as const;

/** Checkout, payments, and stock validation must always hit the network. */
export const CHECKOUT_FETCH_POLICY = 'network-only' as const;

/** Prevents tab-refocus storms on heavy queries (orders, addresses, catalog). */
export const HEAVY_QUERY_WATCH_OPTIONS = {
  refetchOnWindowFocus: false,
  notifyOnNetworkStatusChange: false,
} as const;

export const CATALOG_WATCH_OPTIONS = {
  fetchPolicy: CATALOG_FETCH_POLICY,
  nextFetchPolicy: CATALOG_FETCH_POLICY,
  ...HEAVY_QUERY_WATCH_OPTIONS,
} as const;

export const CHECKOUT_QUERY_OPTIONS = {
  fetchPolicy: CHECKOUT_FETCH_POLICY,
  ...HEAVY_QUERY_WATCH_OPTIONS,
} as const;
